import type {
  CreateNoteVariables,
  PatientNote,
  UpdateNotePayload,
} from "./hooks/usePatientNotes";

/** A form submission, retained across uncertain responses to avoid duplicates. */
export type PatientNoteDraftSubmission = {
  create: CreateNoteVariables;
  saved: Pick<PatientNote, "id" | "text"> | null;
};

export async function savePatientNoteDraft(
  submission: PatientNoteDraftSubmission,
  text: string,
  create: (payload: CreateNoteVariables) => Promise<PatientNote>,
  update: (payload: UpdateNotePayload) => Promise<PatientNote>,
) {
  // Replay the original body/key even if the draft changed after a lost
  // response. Once its id is known, update that note with the latest text.
  if (!submission.saved) {
    submission.saved = await create(submission.create);
  }
  if (submission.saved.text !== text) {
    submission.saved = await update({
      noteId: submission.saved.id,
      text,
    });
  }
  return submission.saved;
}
